import { mapActions, mapState } from 'vuex';
import { POST_LOADER_DELAY } from '@/constants';
import { ICategory } from '@/services/asset';
import { IComponent } from '@/services/component';
import checks, { ComponentChecks } from '@/services/checks';
import { GridColumn, GridForm, GridRow } from '@/components/grid';
import AssetManagerBox from '@/components/asset-manager/AssetManagerBox.vue';
import AssetManagerRegion from '@/components/asset-manager/AssetManagerRegion.vue';
import AssetManagerSlideshow from '@/components/asset-manager/AssetManagerSlideshow.vue';
import CheckList from '@/components/CheckList.vue';
import ChromeEditor from '@/components/chrome/Editor.vue';
import ChromeEditorPanel from '@/components/chrome/EditorPanel.vue';
import FieldBase from '@/components/field/Base.vue';
import FullscreenButton from '@/components/FullscreenButton.vue';
import PricingTable from '@/components/PricingTable.vue';
import ProductUsePanel from '@/components/product/ProductUsePanel.vue';
import PropsTable from '@/components/PropsTable.vue';
import SidebarPanel from '@/components/sidebar/SidebarPanel.vue';
import VendorEditorPanel from '@/components/vendor/VendorEditorPanel.vue';
import messages from '../../messages';
import { askDelete, createComponent } from '../../common';
import checklistActions from './checks';

export default (storeName: string) => ({
  data() {
    const self = this;
    return {
      checkListActionss: checklistActions(this),
      fetched: false,
      guide: [
        {
          point: '#pricingTable',
        },
        {
          ref: 'pricing',
          point: '#propertiesTable',
          dialog: {
            selector: '#pricingTable',
            content: 'Add price information such as price per item, price for bulk orders, discount prices etc.',
          },
        },
        {
          ref: 'properties',
          point: '#assetRegion',
          dialog: {
            selector: '#propertiesTable',
            content: 'Add valuable information such as dimensions, colours, finishing, weight, composition etc.',
          },
        },
        {
          point: '[class*="SidebarWrapper_toolbar"] [title="Vendors"]',
          dialog: {
            selector: '#assetRegion',
            content: 'Add detailed images of your component including technical drawings, multi-angle and close-up shots.',
          },
        },
        {
          point: '[class*="SidebarWrapper_toolbar"] [title="Checks"]',
          onEnter: () => {
            self.selectPanel('vendors');
            return new Promise(resolve => setTimeout(resolve, 250));
          },
          dialog: {
            selector: '[class*="SidebarWrapper_panelsOuter"]',
            content: 'Add the manufacturers and suppliers of this component to help build a view of your supply chain.',
          },
        },
        {
          onEnter: () => {
            self.selectPanel('checks');
            return new Promise(resolve => setTimeout(resolve, 250));
          },
          dialog: {
            selector: '[class*="SidebarWrapper_panelsOuter"]',
            content: 'Try and complete all the tasks listed to help keep better track of your components and increase confidence during production, distribution and sales.',
          },
        },
      ],
      isMobile: this.$store.state.isMobile,
      settings: {
        name: {
          title: 'Name',
        },
        notes: {
          title: 'Notes',
          type: 'textarea',
          params: {
            newline: true,
          },
        },
      },
    };
  },
  computed: {
    ...mapState('chromeEditor', ['panel']),
    ...mapState(storeName, ['data']),
    assetRecord() {
      return {
        type: ICategory.Component,
        type_id: this.data.id,
      };
    },
    componentId() {
      return this.$route.params.componentId;
    },
    listOfChecks() {
      return checks(ComponentChecks, this.data);
    },
  },
  methods: {
    ...mapActions('chromeEditor', ['selectPanel']),
    ...mapActions(storeName, [
      'create',
      'load',
    ]),
    askDelete() {
      const { id, name } = this.data;
      askDelete
        .bind(this)(id, name)
        .then((deleted: boolean) => (
          deleted && this.$router.push({
            name: 'components',
          })
        ));
    },
    createRecord() {
      createComponent(this);
    },
    async fetchData() {
      // load data, populate
      const result: IComponent = await this.load(this.componentId);
      await this.assetComposerSyncAssets(
        result.assets.map(asset => ({
          ...asset,
          type_id: this.data.id,
        })),
      );
      return result;
    },
    print() {
      window.print();
    },
    selectRef(name: string) {
      this.selectPanel('info');

      // wait for animation to finish before focusing on element
      setTimeout(() => {
        const { $el } = this.$refs[name][0];
        $el.querySelector('input,textarea').focus();
      }, 500);
    },
    save() {
      const promise = this.$store
        .dispatch(`${storeName}/save`)
        .catch((error: any) => {
          console.error(error);

          this.$store.commit('dialog/CREATE', {
            title: 'Save error',
            content: messages.ERROR_COMPONENT_SAVE,
            compact: true,
            delay: POST_LOADER_DELAY,
            buttons: [{
              text: 'Close',
              click: (message: any) => message.close(),
            }],
          });
        });

      this.$store.commit('loader/ADD', {
        title: 'Saving',
        promise,
      });
    },
  },
  components: {
    AssetManagerBox,
    AssetManagerRegion,
    AssetManagerSlideshow,
    CheckList,
    ChromeEditor,
    ChromeEditorPanel,
    FieldBase,
    FullscreenButton,
    GridColumn,
    GridForm,
    GridRow,
    PricingTable,
    ProductUsePanel,
    PropsTable,
    SidebarPanel,
    VendorEditorPanel,
  },
} as IView);
